<template>
    <modal ref="modalNuevaPregunta" titulo="Nueva Pregunta" no-aceptar adicional="Guardar" @adicional="guardarPreguntaFrecuenteHija">
        <ValidationObserver ref="formHija">
                <div class="row mx-0 j-center">
                    <div class="col-9 mb-1 mt-2">
                        <p class="label pl-3">
                            Nombre de la pregunta
                        </p>
                        <ValidationProvider v-slot="{errors}" rules="required|max:80" name="titulo">
                            <el-input v-model="titulo" class="w-100" placeholder="Nombre" maxlength="80" show-word-limit size="small" />
                            <p class="text-danger f-10">{{ errors[0] }}</p>
                        </ValidationProvider>
                    </div>
                    <div class="col-9 mt-2 mb-2">
                        <p class="label pl-3">
                            Respuesta
                        </p>
                        <ValidationProvider v-slot="{errors}" rules="required|max:1000" name="respuesta">
                            <el-input v-model="respuesta" placeholder="Respuesta"  type="textarea" :rows="5" maxlength="1000" show-word-limit class="w-100" size="small" />
                            <p class="text-danger f-10">{{ errors[0] }}</p>
                        </ValidationProvider>
                    </div>
                </div>
        </ValidationObserver>
    </modal>
</template>

<script>
import Configuracion from '@/services/configuracion'
export default {
    data(){
        return {
            titulo: '',
            respuesta: '',
            idPadre: null
        }
    },
    methods: {
        toggle(idPadre){
            this.$refs.formHija.reset()
            this.titulo = null
            this.respuesta = null

            this.idPadre = idPadre
            this.$refs.modalNuevaPregunta.toggle();
        },
        async guardarPreguntaFrecuenteHija(){
            try {
                
                let validate = await this.$refs.formHija.validate()
                if(!validate) return this.notificacion('','Campos incompletos')

                let params = {
                    id_padre: this.idPadre,
                    tipo: 1,
                    titulo: this.titulo,
                    respuesta: this.respuesta
                }

                const { data } = await Configuracion.guardarFaq(params)

                this.notificacion('','Pregunta creada correctamente','success')
                this.$refs.modalNuevaPregunta.toggle();
                
                this.$emit('actualizar')
            } catch (error) {
                this.error_catch(error)
            }
        },

    }
}
</script>
<style lang="scss" scoped>
.label{
    font-size: 12px;
    color: var(--text-general);
}
</style>